import React from "react";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { useHistory } from "react-router-dom";

const DeviceTrackingCard = ({ medicalUserDetail }) => {
  const history = useHistory();

  return (
    <div className="sp_device_tracking_card">
      <div className="sp_device_images_container">
        {medicalUserDetail?.device_images &&
        medicalUserDetail?.device_images?.length > 0
          ? medicalUserDetail?.device_images?.map((item, index) => (
              <img
                key={index}
                src={item?.image_url}
                alt="Device"
                className="sp_device_image"
              />
            ))
          : null}
      </div>
      <h3 className="sp_device_tracking_title">
        {titles?.device_and_tracking}
      </h3>
      <CustomButton
        text={titles?.see_devices}
        width="100%"
        onClick={() => history.push(ROUTES_CONSTANTS?.deviceAndTracking)}
      />
    </div>
  );
};

export default DeviceTrackingCard;
